export default __webpack_public_path__ + "static/media/icon6.42439477.png";